( function () {
	'use strict';

	/* @ngInject */
	/* eslint-disable max-params */
	function VideoInfoCtrl ( config, Session, $filter, ppdFactory ) {
		var self = this;

		self.session   = Session.getCredentials().sessionToken;
		self.userId    = Session.getCredentials().userId;
		self.sourceURL = 'https://upload.content.pd360.com/PD360/media/thumb/';
		self.baseURL   = config.homeLink[ window.location.hostname ];

		function getContentDetails () {
			var params = {
				'userId'    : self.userId,
				'contentId' : self.info.id
			};

			self.loading = true;

			ppdFactory.getContentDetails( params )
			.then( function ( res ) {
				self.imgURL     = self.sourceURL + ( res.imageURL || 'sinet-logo.png' );
				self.vidURL     = self.baseURL + '?token=' + self.session  + '#/resources/videos/' + res.contentId;
				self.timeLength = $filter( 'convertSecsToMins' )( res.segmentLengthInSeconds );
				self.description = res.contentDescription;
			} )
			.finally( function () {
				self.loading = false;
			} );
		}

		function activate () {
			getContentDetails();
		}

		activate();
	}

	angular
		.module( 'app.components' )
		.controller( 'VideoInfoCtrl', VideoInfoCtrl );

	VideoInfoCtrl.$inject = [ 'config', 'Session', '$filter', 'ppdFactory' ];
} )( );
